import test from './modules/test'
import cart from './modules/cart'
import common from './modules/common'
import goods from './modules/goods'
import home from './modules/home'
import order from './modules/order'
import promotion from './modules/promotion'
import user from './modules/user'


export default {
  test,
  cart,
  home,
  common,
  goods,
  order,
  promotion,
  user,
}



// WEBPACK FOOTER //
// ./src/api/index.js